module.exports = __webpack_public_path__ + "static/media/mas_logo.4952b8f8.jpg";